import { createFileRoute, redirect } from '@tanstack/react-router';

import { providerSections } from '@/features/providers';

/*
 * Bare `/providers/:id` redirects to the first section (profile), matching the
 * prototype's default-section behavior. The sectioned view lives in
 * `$providerId/$section`.
 */
export const Route = createFileRoute('/_auth/providers/$providerId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/providers/$providerId/$section',
      params: {
        providerId: params.providerId,
        section: providerSections[0]!.id,
      },
      replace: true,
    });
  },
});
